import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    flex-grow: 1;
`;

export const LayoutCardWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    & > * {
        flex-grow: 1;
    }
`;

export const PaginationWrapper = styled('div')<{ isHidden: boolean }>`
    display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
    padding: 10px 20px 0;
    background-color: ${COLORS.newBg};
`;
